module.exports = __webpack_public_path__ + "static/media/056-girl-6.389e8e26.svg";